import { render, staticRenderFns } from "./PartsArrow.vue?vue&type=template&id=6ca652b4&scoped=true&"
import script from "./PartsArrow.vue?vue&type=script&lang=js&"
export * from "./PartsArrow.vue?vue&type=script&lang=js&"
import style0 from "./PartsArrow.vue?vue&type=style&index=0&id=6ca652b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca652b4",
  null
  
)

export default component.exports